var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"logo"},[_vm._v("XLAG.cn")]),_c('div',{staticClass:"center"},[_vm._v(" 互联网ICP备案： "),_c('a',{staticClass:"link-txt",attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("豫ICP备2025138733号-4")])])])
}]

export { render, staticRenderFns }